import React, { useState } from 'react';
import ReactPlayer from 'react-player';
import Img from 'gatsby-image'
import CardStyle from './mediacard.module.css'
import {Link} from 'components/link'
import {ReactComponent as DownloadIcon} from 'images/icons/download_arrow.svg'


const DownloadButton = (props) => {
  return (
    <button className={CardStyle.button}><DownloadIcon className="fill-current stroke-current"/></button>
  )
}

export const DownloadCard = React.forwardRef( (props, ref) => (
  <div className={CardStyle.container} ref={ref}>
    {props.featured_media && props.featured_media.localFile && props.featured_media.localFile.childImageSharp &&
     <div className={CardStyle.media}>
       <Img
         fluid={props.featured_media.localFile.childImageSharp.fluid}
         className={CardStyle.image}
         style={{
           height:"100%",
           width: "100%"
         }}
     />
     </div>
      }

    <div className="flex items-center justify-between p-1 ">
      <div className="mr-5">
        {props.date && 
         <div className={CardStyle.top}>{props.date}</div>
        }
        <div className={CardStyle.title} dangerouslySetInnerHTML={{__html:props.title}}/>

      </div>
      <div>
        <Link to={props.link.url} target={props.link.target}><DownloadButton/></Link>
      </div>
    </div>
  </div>
))
